import { createSlice } from "@reduxjs/toolkit";

interface InitialOrderlinesStateType {
  listLoading: boolean;
  actionsLoading: boolean;
  totalCount: number;
  entities: null | undefined | any[];
  lineForEdit: undefined;
  lastError: null;
  error?: unknown;
}

const initialOrderlinesState: InitialOrderlinesStateType = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  lineForEdit: undefined,
  lastError: null,
};

export const callTypes = {
  list: "list",
  action: "action",
};

export const orderlinesSlice = createSlice({
  name: "orderlines",
  initialState: initialOrderlinesState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },

    lineCreated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
    },

    linesFetched: (state, action) => {
      state.listLoading = false;
      state.error = null;
      state.entities = action.payload;
    },
    lineDeleted: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.entities = state.entities?.filter(
        (e: any) => e.id !== action.payload.id
      );
    },
  },
});
